import { render, staticRenderFns } from "./WorkGeneralInformation.vue?vue&type=template&id=c2053b2e&scoped=true&"
import script from "./WorkGeneralInformation.vue?vue&type=script&lang=js&"
export * from "./WorkGeneralInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2053b2e",
  null
  
)

export default component.exports